import React from 'react';
import { saveAs } from 'file-saver';
//import { Packer, Document, Paragraph,TextRun } from 'docx';
import {Document, Packer, Paragraph, TextRun, Table, TableCell, TableRow, ImageRun, AlignmentType, PageBreak } from "docx";
import { Buffer } from 'buffer';
import { currencyFormat } from '../../js/Functions';
import { logoAmericanLighting, firmaMelissaEscorcia, firmaPaolaPalmieri } from "./ImgActas";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileWord,} from '@fortawesome/free-solid-svg-icons';

class WordActasInterventorias extends React.Component {
 
  generateDocx = () => {
    const {datos} = this.props;
    const getMonthActa = (date) => {
      let mesActa = ''
      switch (date.slice(-2)) {
          case '01': mesActa = "Enero"; break;
          case '02': mesActa = "Febrero"; break;
          case '03': mesActa = "Marzo"; break;
          case '04': mesActa = "Abril"; break;
          case '05': mesActa = "Mayo"; break;
          case '06': mesActa = "Junio"; break;
          case '07': mesActa = "Julio"; break;
          case '08': mesActa = "Agosto"; break;
          case '09': mesActa = "Septiembre"; break;
          case '10': mesActa = "Octubre"; break;
          case '11': mesActa = "Noviembre"; break;
          case '12': mesActa = "Diciembre"; break;
          default: break;
      }
      return mesActa;
    }

    const getMonthLiquidacionActa = (date) => {
      let mesLiquidacionActa = ''
      switch (date.slice(-2)) {
          case '01': mesLiquidacionActa = "Enero"; break;
          case '02': mesLiquidacionActa = "Febrero"; break;
          case '03': mesLiquidacionActa = "Marzo"; break;
          case '04': mesLiquidacionActa = "Abril"; break;
          case '05': mesLiquidacionActa = "Mayo"; break;
          case '06': mesLiquidacionActa = "Junio"; break;
          case '07': mesLiquidacionActa = "Julio"; break;
          case '08': mesLiquidacionActa = "Agosto"; break;
          case '09': mesLiquidacionActa = "Septiembre"; break;
          case '10': mesLiquidacionActa = "Octubre"; break;
          case '11': mesLiquidacionActa = "Noviembre"; break;
          case '12': mesLiquidacionActa = "Diciembre"; break;
          default: break;
      }
      return mesLiquidacionActa;
    }

    if(datos[0]){
      const dateStr = datos[0].resultActa.FECHA_ACTA;
      const date = new Date(dateStr);

      const options = {
          day: 'numeric',
          month: 'long',
          year: 'numeric',
          timeZone: 'UTC',
          locale: 'es-CO'
      };

      const colombianDate = date.toLocaleDateString('es-CO', options);
      const monthActa = getMonthActa(datos[0].resultActa.PERIODO_ACTA)
      const monthLiquidacionActa = getMonthLiquidacionActa(datos[0].resultActa.PERIODO_LIQUIDACION)
      let totalFactRecaudo = 0;
      let tableRowsFacturacion: TableRow[] = [];
      let tableRowsConcesion: TableRow[] = [];
      let filename = datos[0].resultActa.PERIODO_ACTA ? `Acta de Interventoria ${datos[0].resultActa.MUNICIPIO} - ${datos[0].resultActa.PERIODO_ACTA}.docx`: 'Acta de Interventoria.docx'
      


      if (datos[0]) {

        tableRowsFacturacion.push(
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        children: [new Paragraph({ children: [new TextRun({ text: "Descripción:", bold: true })], alignment: AlignmentType.CENTER })],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        columnSpan: 3,
                        children: [new Paragraph({ children: [new TextRun({ text: "Facturación Otros Agentes de Recaudo.", bold: true })], alignment: AlignmentType.CENTER })],
                    }),
                ],
            }),
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "FUENTE DEL RECAUDO", bold: true, size: 17 })], alignment: AlignmentType.CENTER })],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({ text: "VALOR", bold: true, size: 17 }),
                                    new TextRun({ text: "TRASLADO", break: 1, bold: true, size: 17 }),
                                ], alignment: AlignmentType.CENTER
                            })
                        ],
                    }),
                    new TableCell({
                        children: [new Paragraph({
                            children: [
                                new TextRun({ text: "AGENTE", bold: true, size: 17 }),
                                new TextRun({ text: "RECAUDADOR", break: 1, bold: true, size: 17 })
                            ], alignment: AlignmentType.CENTER
                        })],
                    }),
                ],
            }),
        );
        // tableRowsConcesion
        tableRowsConcesion.push(
            new TableRow({
                children: [

                    new TableCell({
                        columnSpan: 5,
                        children: [new Paragraph({ children: [new TextRun({ text: "Descripción:", bold: true })], alignment: AlignmentType.CENTER, },)],
                    }),

                ],
            }),
            new TableRow({

                children: [

                    new TableCell({
                        columnSpan: 5,
                        children: [new Paragraph({ children: [new TextRun({ text: "Factura Realizada por el Concesionario.", bold: true })], alignment: AlignmentType.CENTER, })],
                    }),

                ],
            }),
            new TableRow({
                children: [
                    new TableCell({

                        children: [new Paragraph({ children: [new TextRun({ text: "NO. FACTURA", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                    }),
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "FECHA FACTURA", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                    }),
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "CONCEPTO", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                    }),
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "PERIODO", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                    }),
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "VALOR BRUTO + I.V.A.", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                    }),
                ],
            }),
        )

    }

    // APORTES
    if (datos[0].resultAportes.length > 0) {
        datos[0].resultAportes.forEach((aporte) => {
            totalFactRecaudo += aporte.VALOR_RECAUDO
            tableRowsFacturacion.push(new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: `MUNICIPIO`, size: 17 })],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `$ ${currencyFormat(aporte.VALOR_RECAUDO)}`,
                                        size: 17,
                                    }),
                                ],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `MUNICIPIO`,
                                        size: 17,
                                    }),
                                ],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                ],
            }))
        })
    }
    // MUNICIPIO
    if (datos[0].resultMunicipio.length > 0) {
        datos[0].resultMunicipio.forEach((municipio) => {
            totalFactRecaudo += municipio.VALOR_RECAUDO
            tableRowsFacturacion.push(new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: `${municipio.NOMBRE}`, size: 17 })],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `$ ${currencyFormat(municipio.VALOR_RECAUDO)}`,
                                        size: 17,
                                    }),
                                ],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `MUNICIPIO`,
                                        size: 17,
                                    }),
                                ],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                ],
            }))
        })
    }
    // COMER
    if (datos[0].resultComer.length > 0) {
        datos[0].resultComer.forEach((comer) => {
            totalFactRecaudo += comer.VALOR_RECAUDO
            tableRowsFacturacion.push(new TableRow({
                children: [
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [new TextRun({ text: `${comer.NOMBRE}`, size: 17 })],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `$ ${currencyFormat(comer.VALOR_RECAUDO)}`,
                                        size: 17,
                                    }),
                                ],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                    new TableCell({
                        children: [
                            new Paragraph({
                                children: [
                                    new TextRun({
                                        text: `COMERCIALIZADORA`,
                                        size: 17,
                                    }),
                                ],
                                alignment: AlignmentType.CENTER,
                            }),
                        ],
                    }),
                ],
            }))
        })
    }

    // tableRowsConcesion
    if (datos[0].resultConcesion.length > 0) {
        datos[0].resultConcesion.forEach((concesion) => {
            tableRowsConcesion.push(
                new TableRow({
                    children: [
                        new TableCell({
                            children: [new Paragraph({ children: [new TextRun({ text: `${concesion.NO_FACTURA}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                        }),
                        new TableCell({
                            children: [new Paragraph({ children: [new TextRun({ text: `${concesion.FECHA_FACTURA}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                        }),
                        new TableCell({
                            children: [new Paragraph({ children: [new TextRun({ text: `${concesion.NOMBRE}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                        }),
                        new TableCell({
                            children: [new Paragraph({ children: [new TextRun({ text: `${concesion.PERIODO}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                        }),
                        new TableCell({
                            children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(concesion.VALOR_NETO_LOCAL)}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                        }),
                    ],
                }),
            )
        })
    }
    // CALCULAR Y ANEXAR LA FILA DEL TOTAL 
    if (datos[0]) {
        tableRowsFacturacion.push(
            new TableRow({
                children: [
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "TOTAL", size: 17, bold: true })], alignment: AlignmentType.CENTER, })],
                    }),
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(totalFactRecaudo)}`, size: 17, bold: true })], alignment: AlignmentType.CENTER, })],
                    }),
                    new TableCell({
                        children: [new Paragraph({ children: [new TextRun({ text: "", })], })],
                    }),

                ],
            }),
        )
    }
    const doc = new Document({
        sections: [
            {
                properties: {},
                children: [
                   
                    new Paragraph({
                        children: [
                            new ImageRun({
                                data: Buffer.from(logoAmericanLighting, "base64"),
                                transformation: {
                                    width: 100,
                                    height: 100,
                                },
                            }),
                        ],
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: `${datos[0].resultActa.MUNICIPIO.toUpperCase()}, ${colombianDate}`, break: 1, }),
                            new TextRun({ text: `Señores:`, break: 3 }),
                            new TextRun({ text: `MUNICIPIO DE ${datos[0].resultActa.MUNICIPIO}`, break: 1, bold: true, }),
                            new TextRun({ text: `Att: SUPERVISOR CONTRATO DE CONCESIÓN ALUMBRADO PÚBLICO`, break: 1, }),
                            new TextRun({ text: `${datos[0].resultActa.DEPARTAMENTO.toUpperCase()} - ${datos[0].resultActa.MUNICIPIO.toUpperCase()}`, break: 1 }),
                            new TextRun({ text: `ASUNTO:`, bold: true, break: 1 }),
                            new TextRun({ text: ` ENTREGA DE INFORME MES `, }),
                            new TextRun({ text: `${monthActa.toUpperCase()} ${datos[0].resultActa.PERIODO_ACTA.slice(0, -2)}`, bold: true, }),
                            new TextRun({ text: `Cordial saludo,`, break: 3 }),
                            new TextRun({ text: `En nuestra calidad de Concesionario nos permitimos remitir la información correspondiente a la gestión adelantada en el periodo de: `, break: 2 }),
                            new TextRun({ text: `${monthActa} ${datos[0].resultActa.PERIODO_ACTA.slice(0, -2)}`, bold: true, }),
                            new TextRun({ text: ` `, break: 2, }),
                        ],
                    }),
                    //  FINAL PARRAFOS DEL ENCABEZADO

                    //  TABLE
                    new Table({
                        width: { size: '100%' },
                        rows: [
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: "No.:", bold: true })], alignment: AlignmentType.CENTER, })],
                                        width: { size: "10%" }
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: "Documento", bold: true })], alignment: AlignmentType.CENTER })],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "1", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Informes Operativos', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "1.1", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Listado de reportes de daños de luminarias de Alumbrado Público presentado por los usuarios.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, },)],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "1.2", alignment: AlignmentType.CENTER, spacing: { before: 330 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Listado de luminarias a las cuales se les realizó mantenimiento indicando: fecha de mantenimiento, código de luminaria a la cual se le realizo el mantenimiento, elementos cambiados a la luminaria y dirección y/o lugar de ubicación de la luminaria.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "1.3", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Expansiones en alumbrado público realizadas en el periodo.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),
                                ],
                            }),

                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "2", alignment: AlignmentType.CENTER, spacing: { before: 650 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [
                                            new Paragraph({ text: 'Informe de gestión donde se evidencian el resultado de los indicadores contractuales del mes y que incluye lo siguiente:', spacing: { before: 100, after: 50, }, indent: { left: 100, } },),
                                            new Paragraph({
                                                children: [
                                                    new TextRun({ text: '\n•  Efectividad de ejecución de mantenimientos preventivos.', break: 1, }),
                                                    new TextRun({ text: '\n•  Efectividad de ejecución para cerrar solicitudes.', break: 1 }),
                                                    new TextRun({ text: '\n•  Plazo medio de resolución.', break: 1 })
                                                ],
                                                indent: { left: 300, },
                                                spacing: { after: 100 }
                                            },)
                                        ],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "3", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Conciliación de facturación y recaudo del impuesto de alumbrado público mensual.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "4", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Extracto Fiduciarios y Bancarios.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "5", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Copia de factura por operación y mantenimiento y retorno a la inversión.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "6", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Ordenes de traslado Encargo Fiduciario.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "7", alignment: AlignmentType.CENTER, spacing: { before: 200 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Certificado de pago oportuno a los sistemas de seguridad social en salud, pensión, riesgos profesionales, correspondientes a los trabajadores y/o empleados durante el último mes.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ text: "8", alignment: AlignmentType.CENTER, spacing: { before: 100 } })],
                                        width: { size: "10%" },
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ text: 'Pólizas de garantía del contrato de concesión de alumbrado público.', spacing: { before: 100, after: 100 }, indent: { left: 100, }, })],
                                    }),

                                ],
                            }),

                        ],
                    }),
                    // FIN FIRST TABLE
                    // PAGE BREAK
                    new Paragraph({ children: [new TextRun(''), new PageBreak()] }),

                    new Paragraph({
                        children: [
                            new TextRun({ text: `Así mismo, durante el periodo se realizaron las siguientes actividades de apoyo a la gestión: ${datos[0].resultActa.OBSERVACIONES.toUpperCase()}`, }),
                            new TextRun({ text: `De acuerdo con lo anterior se deja constancia del cumplimiento de las obligaciones contractuales, quedando atentos a cualquier inquietud o comentario sobre la información entregada.`, break: 2 }),
                            new TextRun({ text: `Atentamente,`, break: 4 }),
                            new TextRun({ text: ``, break: 4 }),
                        ],
                    }),

                    new Paragraph({
                        children: [
                            new ImageRun({
                                data: Buffer.from(firmaPaolaPalmieri, "base64"),
                                transformation: {
                                    width: 160,
                                    height: 60,
                                },
                            }),
                        ],
                    }),
                    new Paragraph({
                        children: [
                            new TextRun({ text: `PAOLA PALMIERI M`, bold: true, break: 1 }),
                            new TextRun({ text: `JEFE DE OPERACIONES COMERCIALES`, break: 1 }),
                            new TextRun({ text: `UNIDAD DE ALUMBRADO PÚBLICO`, break: 1 }),
                        ]
                    }),

                    // PAGE BREAK
                    new Paragraph({ children: [new TextRun(''), new PageBreak()] }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        children: [
                            new TextRun({ text: `6. Conciliación de Facturación y Recaudo del Impuesto de Alumbrado Público Mensual. Periodo: ${monthLiquidacionActa} ${datos[0].resultActa.PERIODO_LIQUIDACION.slice(0, -2)}`, bold: true, size: 25 }),
                            new TextRun({ text: ``, break: 2 }),
                        ],
                    }),


                    // SECOND TABLE
                    new Table({
                        alignment: AlignmentType.CENTER,
                        width: { size: '100%' },
                        rows: [

                            new TableRow({
                                children: [

                                    new TableCell({
                                        columnSpan: 5,
                                        children: [new Paragraph({ children: [new TextRun({ text: "Descripción:", bold: true })], alignment: AlignmentType.CENTER, },)],
                                    }),

                                ],
                            }),
                            new TableRow({

                                children: [

                                    new TableCell({
                                        columnSpan: 5,
                                        children: [new Paragraph({ children: [new TextRun({ text: "Liquidación Operador de Red.", bold: true })], alignment: AlignmentType.CENTER, })],
                                    }),

                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({

                                        children: [new Paragraph({ children: [new TextRun({ text: "FACTURADO", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: "RECAUDO", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: "COSTO DE ENERGIA", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: "OTRAS DEDUCCIONES", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: " TRASLADO NETO", bold: true, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                ],
                            }),
                            new TableRow({
                                children: [
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(datos[0].resultActa.VALOR_FACTURADO)}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(datos[0].resultActa.VALOR_RECAUDO)}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(datos[0].resultActa.COSTO_ENERGIA)}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(datos[0].resultActa.OTRAS_DEDUCCIONES)}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                    new TableCell({
                                        children: [new Paragraph({ children: [new TextRun({ text: `$ ${currencyFormat(datos[0].resultActa.TRASLADO_NETO)}`, size: 17 })], alignment: AlignmentType.CENTER, })],
                                    }),
                                ],
                            }),

                        ],
                    }),
                    //  FIN TABLE
                    new Paragraph({ children: [new TextRun({ text: " ", break: 1 })], },),

                    // THIRD TABLE                      
                    new Table({
                        alignment: AlignmentType.CENTER,
                        width: { size: '100%' },
                        rows: tableRowsFacturacion,
                    }),
                    // FIN TABLE

                    // PAGE BREAK
                    new Paragraph({ children: [new TextRun(''), new PageBreak()] }),
                    new Paragraph({
                        alignment: AlignmentType.CENTER,
                        children: [
                            new TextRun({ text: `8. Facturación por Operación y Mantenimiento y Retorno de la Inversión`, bold: true, size: 25 }),
                            new TextRun({ text: ``, break: 2 }),
                        ],
                    }),

                    // FOURTH TABLE
                    new Table({
                        alignment: AlignmentType.CENTER,
                        width: { size: '100%' },
                        rows: tableRowsConcesion,
                    }),
                    //  FIN TABLE
                ],

            },
        ],
    });
    Packer.toBlob(doc).then(blob => {
      saveAs(blob, filename);
    });
    }
  };

  render() {
    return (
      <button
        style={{ color: '#FFFFFF' }}
        type="button"
        className="btn btn-info btn-sm"
        onClick={this.generateDocx}
      >
        <FontAwesomeIcon style={{ color: '#FFFFFF' }} icon={faFileWord} />
      </button>
    );
  }
}
export default WordActasInterventorias;
